module.exports = __webpack_public_path__ + "static/media/c++.2389c949.png";